export default __webpack_public_path__ + "static/media/line-light.434232ae.svg";